import { render } from "./BarChartDemo.vue?vue&type=template&id=15813f2a&scoped=true"
import script from "./BarChartDemo.vue?vue&type=script&lang=ts"
export * from "./BarChartDemo.vue?vue&type=script&lang=ts"

import "./BarChartDemo.vue?vue&type=style&index=0&id=15813f2a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-15813f2a"

export default script